// src/belediye/pages/notifications/BildirimKopruPage.js
//
// FAZ-84 §9 — TELEFON BİLDİRİMİ KÖPRÜ ROTASI  (/yonetim/b/:bildirimId)
//
// NEDEN VAR: nöbetçi (public/sw.js) oturumu okuyamaz ve bir bildirimin nereye
// gittiğini bilemez. Yönlendirme mantığını nöbetçiye KOPYALASAYDIK, aynı kural
// iki yerde yaşardı ve bu projede kopyalanan kural her seferinde saptı
// (FAZ-48, FAZ-16, FAZ-82). Bu yüzden nöbetçi yalnız buraya gelir; hedefi
// resolveNotificationTarget (FAZ-47 TEK kaynak) çözer.
//
// GİRİŞ YAPILMAMIŞSA: bu rota korumalı alanın içindedir; BelediyeApp koruması
// kişiyi `/giris?next=/yonetim/b/<id>`e gönderir ve giriş sonrası buraya
// GERİ DÖNER (FAZ-63 zinciri — yeni kod gerekmedi).
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { getNotification, markNotificationsRead } from "../../services/bildirimApi";
import resolveNotificationTarget from "../../components/notifications/resolveNotificationTarget";
import { openChat } from "../../services/mesajlasmaBridge";

const YEDEK_ROTA = "/yonetim/bildirimler";

export default function BildirimKopruPage() {
  const { bildirimId } = useParams();
  const navigate = useNavigate();
  const [hata, setHata] = useState("");
  // StrictMode çift-çalıştırmasında iki kez yönlendirmeyi engeller.
  const calisti = useRef(false);

  useEffect(() => {
    if (calisti.current) return;
    calisti.current = true;

    const id = Number(bildirimId);
    if (!Number.isFinite(id) || id <= 0) {
      navigate(YEDEK_ROTA, { replace: true });
      return;
    }

    let iptal = false;

    (async () => {
      let satir = null;
      try {
        satir = await getNotification(id);
      } catch (_) {
        // Satır bulunamadı (silinmiş / başkasına ait). Kullanıcıyı boşlukta
        // bırakmayız: bildirim merkezine düşer.
        if (!iptal) navigate(YEDEK_ROTA, { replace: true });
        return;
      }
      if (iptal) return;

      // Bildirime TELEFONDAN dokunmak = okumak. Zil sayacı ile telefon rozeti
      // birbirinden ayrışmasın diye burada okundu işaretlenir.
      try {
        await markNotificationsRead([id]);
      } catch (_) {}

      if (iptal) return;

      const hedef = resolveNotificationTarget(satir, { allowChat: true });

      if (hedef && hedef.kind === "chat") {
        // Sohbet bildirimi ROTAYA çevrilmez: dock'ta YERİNDE açılır
        // (FAZ-52 kuralı — "Mesajlar" sayfası kaldırılmıştı).
        try {
          openChat(hedef.conversationId);
        } catch (_) {}
        navigate(YEDEK_ROTA, { replace: true });
        return;
      }

      if (hedef && hedef.kind === "route" && hedef.path) {
        navigate(hedef.path, { replace: true });
        return;
      }

      // Çözülemeyen bildirim türü: merkeze düş, kaybolma.
      setHata("Bu bildirim için açılacak bir sayfa bulunamadı.");
      navigate(YEDEK_ROTA, { replace: true });
    })();

    return () => {
      iptal = true;
    };
  }, [bildirimId, navigate]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        padding: 24,
        textAlign: "center",
        color: "var(--text-muted, #6b7a89)",
        fontSize: 15,
      }}
      role="status"
      aria-live="polite"
    >
      {hata || "Bildirim açılıyor…"}
    </div>
  );
}
